<template>
  <div v-if="pagemodel">
    <div class="flex align-center between">
      <label>
        <input type="checkbox" v-model="pagemodel.published" />
        <b class="xs-font">Publish Page</b>
      </label>
      <i
        @click="!pagemodel.hook ? $set(pagemodel, 'hook', {}) : null"
        class="fa fa-fish"
      ></i>
      <hooks
        v-if="pagemodel.hook"
        :name="'page_' + input.label"
        :value="pagemodel.hook"
        :item="pagemodel.hook"
      />
      <label>
        <input type="checkbox" v-model="pagemodel.automenu" />
        <b class="xs-font">Create menu</b>
      </label>
      <rm
        :obj="$store.state.app.pages"
        :name="page"
        :fn="{
          command: 'dispatch',
          method: 'update',
          type: 'app',
          data: { data: $store.state.app },
        }"
      />
    </div>
    <div
      v-if="
        input.inputType === 'page' &&
        input.default &&
        input.default['pages'] &&
        input.default['components'] &&
        page
      "
    >
      <textarea
        :required="input.required"
        style="width: -webkit-fill-available"
        class="sm-font"
        v-model="pagemodel.text"
        :id="input.label.norm() + 'text'"
        :class="input.label.norm() + 'text'"
        :type="input.type"
        :placeholder="input.placeholder + ' - markdown enabled -'"
      ></textarea>
      <!-- Select Multiple Pages and Components  -->
      <div class="container pages">
        <!-- // TODO remove this or reevaluate how to impliment -->

        <div page-components class="sub-container">
          <row j="between">
            <b> <i class="fa fa-boxes" /> Components </b>
            <span>Select components to add to page</span>
            <b
              class="flex align-center"
              @click="
                $set(
                  show,
                  'pageselectcomponents' + input.label,
                  !show['pageselectcomponents' + input.label]
                )
              "
            >
              <i
                :class="`r8 fa-lg fa fa-${
                  show['pageselectcomponents' + input.label] ? 'minus' : 'plus'
                }`"
              />
            </b>
          </row>
          <div
            v-if="show['pageselectcomponents' + input.label]"
            :required="input.required"
            class="xs-font flex column"
          >
            <div
              class="flex p4 align-center"
              v-for="(components, componentcategory) in $store.state.components"
              :key="componentcategory + $store.state.counter"
            >
              <p class="indicate-text border-bottom">{{ componentcategory }}</p>
              <!-- compkey === component name -->
              <div class="flex wrap align-center">
                <span
                  class="flex wrap"
                  v-for="(comp, compkey) in components"
                  :key="compkey"
                  @click="
                    pagemodel.components.push({
                      name: comp,
                      props: {},
                      styles: {},
                    })
                  "
                >
                  <span
                    :class="
                      pagemodel.components && pagemodel.components[comp]
                        ? 'update-text p8'
                        : 'p4'
                    "
                  >
                    <i
                      v-if="
                        'displayinstancewidgets'.indexOf(componentcategory) >= 0
                      "
                      class="fa-sm fa fa-plus"
                    ></i>
                    {{ comp }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div>
            <div
              v-for="(option, optionkey) in pagemodel.components"
              :key="option.name + optionkey"
            >
              <div class="t8 container p8 indicate-border">
                <div class="flex align-center between xs-font">
                  <div>
                    <i
                      @click="
                        values[0] = option;
                        pagemodel.components[optionkey] =
                          pagemodel.components[optionkey - 1];
                        show['components' + optionkey]
                          ? ((show['components' + optionkey] = false),
                            (show['components' + (optionkey - 1)] = true))
                          : null;
                        $set(pagemodel.components, optionkey - 1, values[0]);
                        values = [];
                      "
                      v-if="optionkey !== 0"
                      class="fa fa-arrow-up r4"
                    ></i>
                    <i
                      @click="
                        values[0] = option;
                        pagemodel.components[optionkey] =
                          pagemodel.components[optionkey + 1];
                        show['components' + optionkey]
                          ? ((show['components' + optionkey] = false),
                            (show['components' + (optionkey + 1)] = true))
                          : null;
                        $set(pagemodel.components, optionkey + 1, values[0]);
                      "
                      v-if="optionkey !== pagemodel.components.length - 1"
                      class="fa fa-arrow-down"
                    ></i>
                  </div>
                  <span
                    @click="
                      $set(
                        show,
                        'components' + optionkey,
                        !show['components' + optionkey]
                      )
                    "
                  >
                    <b class="md-font align-center flex">
                      <i class="fa fa-box r4" />
                      {{ option.name }}
                    </b>
                    <span class="update-text">
                      {{
                        option.props.pagetitle ||
                        option.props.name ||
                        option.props.title ||
                        option.props.type ||
                        option.props.id
                      }}
                    </span>
                  </span>
                  <rm :obj="pagemodel.components" :name="optionkey" />
                </div>
                <div v-if="show['components' + optionkey]">
                  <div
                    class="p4"
                    v-for="(prop, propkey) in $cp[option.name]"
                    :key="propkey"
                  >
                    <div class="update-border p8 xs-font wrap">
                      <b>{{ propkey }}</b>
                      <span class="p8">
                        <div
                          v-if="
                            prop.type === String ||
                            (prop.type.includes && prop.type.includes(String))
                          "
                        >
                          <input
                            class="xs-input"
                            :placeholder="propkey + ' (string)'"
                            type="text"
                            v-model="
                              pagemodel.components[optionkey].props[propkey]
                            "
                          />
                        </div>
                        <div
                          v-if="
                            prop.type === Boolean ||
                            (prop.type.includes && prop.type.includes(Boolean))
                          "
                        >
                          <input
                            class="xs-input"
                            :placeholder="propkey"
                            type="checkbox"
                            v-model="
                              pagemodel.components[optionkey].props[propkey]
                            "
                          />
                          <span
                            @click="
                              $set(
                                pagemodel.components[optionkey].props,
                                propkey,
                                !pagemodel.components[optionkey].props[propkey]
                              )
                            "
                          >
                            <i
                              :class="
                                pagemodel.components &&
                                pagemodel.components[optionkey][propkey]
                                  ? 'update-text'
                                  : ''
                              "
                              >True</i
                            >
                            /
                            <i
                              :class="
                                !pagemodel.components ||
                                !pagemodel.components[optionkey][propkey]
                                  ? 'update-text'
                                  : ''
                              "
                              >False</i
                            >
                          </span>
                        </div>
                        <div
                          v-if="
                            prop.type === Number ||
                            (prop.type.includes && prop.type.includes(Number))
                          "
                        >
                          <input
                            class="xs-input"
                            :placeholder="propkey + ' (number)'"
                            type="number"
                            v-model.number="
                              pagemodel.components[optionkey].props[propkey]
                            "
                          />
                          number
                        </div>

                        <div
                          class
                          v-if="
                            prop.type &&
                            (prop.type === Object ||
                              prop.type === Array ||
                              (prop.type.includes &&
                                (prop.type.includes(Object) ||
                                  prop.type.includes(Array))))
                          "
                        >
                          <div class="flex container">
                            <div
                              class="xs-font"
                              style="max-height: 180px; overflow: scroll"
                            >
                              {{ option.props[propkey] }}
                            </div>
                            <a
                              class="fit"
                              @click="
                                $copyText(JSON.stringify(option.props[propkey]))
                              "
                            >
                              <i class="fa fa-copy"></i> Copy
                            </a>
                          </div>
                          <textarea
                            :placeholder="`${
                              option.name.toUpperCase() +
                              ' ' +
                              propkey.toUpperCase()
                            }\n{ Valid JSON }`"
                            @change="
                              typeof JSON.parse(
                                newInput[
                                  form.name +
                                    '.' +
                                    input.label +
                                    '.components[' +
                                    optionkey +
                                    '].props.' +
                                    propkey
                                ]
                              ) === 'object'
                                ? (option.props[propkey] = JSON.parse(
                                    newInput[
                                      form.name +
                                        '.' +
                                        input.label +
                                        '.components[' +
                                        optionkey +
                                        '].props.' +
                                        propkey
                                    ]
                                  ))
                                : null
                            "
                            v-model="
                              newInput[
                                form.name +
                                  '.' +
                                  input.label +
                                  '.components[' +
                                  optionkey +
                                  '].props.' +
                                  propkey
                              ]
                            "
                          ></textarea>
                        </div>
                      </span>
                      <span class="flex xs-font wrap align-center">
                        <span
                          v-if="
                            $store.state.select[
                              form.name +
                                '.' +
                                input.label +
                                '.components[' +
                                optionkey +
                                '].props.' +
                                propkey
                            ]
                          "
                          class="xs-font m4"
                        >
                          <button
                            class="update m4"
                            type="button"
                            @click="
                              $set(
                                pagemodel.components[optionkey].props,
                                propkey,
                                $store.state.select[
                                  form.name +
                                    '.' +
                                    input.label +
                                    '.components[' +
                                    optionkey +
                                    '].props.' +
                                    propkey
                                ].val
                              )
                            "
                          >
                            Assign Value
                          </button>

                          <button
                            class="indicate m4"
                            type="button"
                            @click="
                              $set(
                                pagemodel.components[optionkey].props,
                                propkey,
                                'p__' +
                                  $store.state.select[
                                    form.name +
                                      '.' +
                                      input.label +
                                      '.components[' +
                                      optionkey +
                                      '].props.' +
                                      propkey
                                  ].parent
                              )
                            "
                          >
                            Assign Pointer
                          </button>
                          <a
                            class="warn-text"
                            @click="
                              $set(
                                $store.state.select,
                                form.name +
                                  '.' +
                                  input.label +
                                  '.components[' +
                                  optionkey +
                                  '].props.' +
                                  propkey,
                                null
                              )
                            "
                            >Clear</a
                          >
                        </span>
                        <a
                          @click="
                            $set(
                              show,
                              form.name +
                                '.' +
                                input.label +
                                '.components[' +
                                optionkey +
                                '].props.' +
                                propkey +
                                '.findvalues',
                              !show[
                                form.name +
                                  '.' +
                                  input.label +
                                  '.components[' +
                                  optionkey +
                                  '].props.' +
                                  propkey +
                                  '.findvalues'
                              ]
                            )
                          "
                        >
                          <i class="fa fa-folder"></i> Find Data
                        </a>
                        <div
                          v-if="
                            show[
                              form.name +
                                '.' +
                                input.label +
                                '.components[' +
                                optionkey +
                                '].props.' +
                                propkey +
                                '.findvalues'
                            ]
                          "
                          class="xs-font container flex p4 wrap align-center"
                        >
                          Find Values
                          <input
                            placeholder="Search State"
                            class="xs-input xs-font"
                            type="text"
                            v-model="
                              search[
                                form.name +
                                  '.' +
                                  input.label +
                                  '.components[' +
                                  optionkey +
                                  '].props.' +
                                  propkey
                              ]
                            "
                          />
                          <state
                            style="display: flex; flex-wrap: wrap"
                            :key="
                              form.name +
                              '.' +
                              input.label +
                              '.components[' +
                              optionkey +
                              '].props.' +
                              propkey +
                              $store.state.counter
                            "
                            :searchdata="
                              search[
                                form.name +
                                  '.' +
                                  input.label +
                                  '.components[' +
                                  optionkey +
                                  '].props.' +
                                  propkey
                              ]
                            "
                            :parent="
                              form.name +
                              '.' +
                              input.label +
                              '.components[' +
                              optionkey +
                              '].props.' +
                              propkey +
                              '.state'
                            "
                            :statedata="$store.state"
                            :select="
                              form.name +
                              '.' +
                              input.label +
                              '.components[' +
                              optionkey +
                              '].props.' +
                              propkey
                            "
                          />
                        </div>
                        <span
                          v-if="
                            $store.state.select[
                              form.name +
                                '.' +
                                input.label +
                                '.components[' +
                                optionkey +
                                '].props.' +
                                propkey
                            ]
                          "
                        >
                          {{
                            $store.state.select[
                              form.name +
                                "." +
                                input.label +
                                ".components[" +
                                optionkey +
                                "].props." +
                                propkey
                            ].val
                          }}
                        </span>
                      </span>
                    </div>
                    <!-- <input v-model="input.default['components'][option][propkey]"/>  -->
                  </div>
                  <div class>
                    <h5>Component Styles</h5>
                    <div class="flex wrap">
                      <div class v-if="option.styles">
                        <div>
                          <h5>Classes</h5>
                          <input
                            placeholder="choose classes to apply"
                            class="xs-font xs-input"
                            type="text"
                            v-model="option.styles.classes"
                          />
                        </div>
                      </div>
                      <div>
                        <h5>Inline Styles</h5>
                        <div class="flex b16">
                          <input
                            type="search"
                            list="cssproperties"
                            class="xs-input xs-font"
                            placeholder="add style property"
                            v-model="
                              newInput[
                                form.name +
                                  '.' +
                                  input.label +
                                  'component.style'
                              ]
                            "
                          />
                          <!-- <select 
                            v-model="
                              newInput[
                                form.name +
                                  '.' +
                                  input.label +
                                  'component.style'
                              ]
                            "
                          >
                            <option
                              v-for="prop in $store.state.lists.cssproperties"
                              :value="prop"
                              :key="prop"
                            >
                              {{ prop }}
                            </option>
                          </select>-->

                          <button
                            :disabled="
                              !newInput[
                                form.name +
                                  '.' +
                                  input.label +
                                  'component.style'
                              ]
                            "
                            type="button"
                            class="update"
                            @click="
                              !option.styles.style
                                ? (option.styles.style = {})
                                : null;
                              $set(
                                option.styles.style,
                                newInput[
                                  form.name +
                                    '.' +
                                    input.label +
                                    'component.style'
                                ],
                                ''
                              );
                              newInput[
                                form.name +
                                  '.' +
                                  input.label +
                                  'component.style'
                              ] = '';
                            "
                          >
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                        <div
                          class="flex align-center p4"
                          v-for="(style, i) in option.styles.style"
                          :key="input.label + 'styles' + i"
                        >
                          <span class="xs-font">{{ i.toUpperCase() }}:</span>
                          <input
                            class="xs-font xs-input flexy"
                            :placeholder="`${i} value`"
                            v-model="option.styles.style[i]"
                          />;
                          <i
                            class="fa fa-trash warn-text"
                            @click="$delete(option.styles.style, i)"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sub-container">
          <div class="flex wrap">
            <div class="flex wrap" v-if="pagemodel.styles">
              <div>
                <h5>Classes</h5>
                <input
                  placeholder="enter classes to apply to this page"
                  class="xs-font xs-input"
                  type="text"
                  v-model="pagemodel.styles.classes"
                />
              </div>
            </div>
            <!-- <div>
                                    <h5>Inline Styles</h5>
                                    <div class="flex b16">
                                      <select
                                        v-model="
                                          newInput[
                                            form.name +
                                              '.' +
                                              input.label +
                                              '.style'
                                          ]
                                        "
                                      >
                                        <option
                                          v-for="prop in $store.state.lists
                                            .cssproperties"
                                          :value="prop"
                                          :key="prop"
                                        >
                                          {{ prop }}
                                        </option>
                                      </select>
                                      <button
                                        :disabled="
                                          !newInput[
                                            form.name +
                                              '.' +
                                              input.label +
                                              '.style'
                                          ]
                                        "
                                        type="button"
                                        class="update"
                                        @click="
                                          !pagemodel.styles
                                            .style
                                            ? (models.pages[
                                                input.label
                                              ].styles.style = {})
                                            : null;
                                          $set(
                                            pagemodel.styles
                                              .style,
                                            newInput[
                                              form.name +
                                                '.' +
                                                input.label +
                                                '.style'
                                            ],
                                            ''
                                          );
                                          newInput[
                                            form.name +
                                              '.' +
                                              input.label +
                                              '.style'
                                          ] = '';
                                        "
                                      >
                                        <i class="fa fa-plus"></i>
                                      </button>
                                    </div>
                                    <div
                                      class="flex align-center p4"
                                      v-for="(style, i) in models.pages[
                                        input.label
                                      ].styles.style"
                                      :key="input.label + 'styles' + i"
                                    >
                                      <span class="xs-font"
                                        >{{ i.toUpperCase() }}:</span
                                      >
                                      <input
                                        class="xs-font xs-input flexy"
                                        :placeholder="`${i} value`"
                                        v-model="
                                          pagemodel.styles
                                            .style[i]
                                        "
                                      />;
                                      <i
                                        class="fa fa-trash warn-text"
                                        @click="
                                          $delete(
                                            pagemodel.styles
                                              .style,
                                            i
                                          )
                                        "
                                      ></i>
                                    </div>
            </div>-->
          </div>
        </div>
        <!-- <div class="sub-container">
                                Routes {{ pagemodel.routes }}
                              </div>
                              <div class="sub-container">
                                Permissions
                                {{ pagemodel.permissions }}
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    page: { type: String },
    pagekey: { type: Number },
    form: { type: Object },
    input: { type: Object },
  },
  data() {
    return { show: {}, newInput: {}, search: "", values:[] };
  },
  computed: {
    pagemodel() {
      return this.$store.state.app.pages[this.page];
    },
  },
};
</script>